// Pauses script for <time> amount of milliseconds
export default async function sleep(time: number) {
  await new Promise((resolve) => {
    setTimeout(() => {
      resolve("done");
    }, time);
  });
}
